export class AbsenceLookup {
    id: number;
    lookupCode: string;
    lookupValue: string;
    description: string;
    workflowRuleKey: string;
    absenseTimeType: string;
    allowedMaxTime: string;
    requiredFileOnOpen: string;
    requiredFileOnClose: string;
    additionalAbsenceDay: number;
    attribute6: string;
    attribute7: string;
    attribute8: string;
    attribute9: string;
    attribute10: string;
    parentLookup: AbsenceLookup;
}
